// ============================================================================
//  money.js — currency formatting helpers used across the frontend
// ============================================================================
//
//  Two variants exist because different pages want different precision:
//
//    fmtMoneyRounded — used on Balances tab where amounts are $10,000+
//      and per-cent precision would just add noise. Rounds to nearest
//      whole dollar. Returns '—' for null/NaN. Uses Unicode minus ('−')
//      for negatives so column alignment matches the wide-Unicode plus.
//
//    fmtMoneyDecimal — used on Outgoing Loads where operators care about
//      the exact cents (small transactions). Returns '' for null/empty
//      so blank cells don't render an em-dash where none belongs.
//
//  Extracted 2026-07-03 from Balances.jsx + OutgoingLoads.jsx during the
//  code-review pass. Both files used to define these inline with the same
//  names, which was confusing when jumping between them.
// ============================================================================

export function fmtMoneyRounded(n) {
  if (n == null || isNaN(n)) return '—';
  const v = Math.round(Number(n));
  return (v < 0 ? '−$' : '$') + Math.abs(v).toLocaleString();
}

export function fmtMoneyDecimal(v) {
  if (v == null || v === '') return '';
  const n = Number(v);
  if (!Number.isFinite(n)) return '';
  return '$' + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
